export default "__VITE_ASSET__DhsWzRka__"